if (!customElements.get('ck-shipping-info')) {
  customElements.define('ck-shipping-info', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.ck-shipping-trigger');
      trigger.addEventListener('click', () => dialog.showModal());
      this.querySelector('.ck-shipping-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
    }
  });
}


